
import {ProfilePublicationModel } from '../models/ProfilePublicationModel.js';
import {ProfilePublicationView } from '../views/ProfilePublicationView.js';

export class ProfilePublicationController {
    constructor() {

        this.model = new ProfilePublicationModel();
        this.view = new ProfilePublicationView();

        this.model.subscribe(state => this.view.render(state));
    }
}